import { HamburgerIcon } from "@chakra-ui/icons";
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import { useFilteredRoutes } from "../../routes";
import { SidebarBrand, SidebarLinks } from "./SidebarLinks";

function SidebarResponsive(props) {
  const filteredRoutes = useFilteredRoutes();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  let hamburgerColor = useColorModeValue("gray.500", "gray.200");
  if (props.secondary === true) {
    hamburgerColor = "white";
  }

  return (
    <Flex display={{ base: "none", md: "flex", xl: "none" }} alignItems="center">
      <HamburgerIcon
        color={hamburgerColor}
        w="18px"
        h="18px"
        ref={btnRef}
        onClick={onOpen}
      />
      <Drawer isOpen={isOpen} onClose={onClose} placement="left" finalFocusRef={btnRef}>
        <DrawerOverlay />
        <DrawerContent w="240px" maxW="240px" bg="#231E1A">
          <DrawerCloseButton color="#fff" />
          <DrawerBody px="16px" py="24px">
            <Flex direction="column" h="100%" color="#fff">
              <SidebarBrand />
              <Box flex="1" overflowY="auto" className="thin-scrollbar">
                <SidebarLinks routes={filteredRoutes} onNavigate={onClose} />
              </Box>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}

export default SidebarResponsive;
